import { ProductTypeModelType } from '@teinor/erp/types/company/product/productType'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
export interface ProductTypesAction {
    type: 'CHANGE_PRODUCT_TYPES'
    payload: ProductTypesPayload
}
export type ProductTypesPayload = ProductTypeModelType[]
export type ProductTypeJson = { [isoCode: string]: ProductTypeModelType } | null
export default function productTypes(state: ProductTypeJson = null, action: ProductTypesAction): ProductTypeJson {
    switch (action.type) {
        case 'CHANGE_PRODUCT_TYPES':
            return state = dictionaryComplexFromJsonArr(action.payload)
        default:
            return state
    }
}